import { ExpenseType, LoadingStatusType, PeakExceptionResponseCode, TypeComponentNoti } from "@/enums/enums";
import { CalculateAllPaymentGroupSummary, CalculateWhtAmount, OnChangeWht } from "@/helper/paymentHelper";
import {
  SetAIChartOfAccount,
  SetAIInvoice,
  SetBookmarkForTransaction,
  SetCopyInvoiceModel,
} from "@/helper/transactionCreateHelper";
import {
  CheckErrorValueInput,
  GetCreateTransactionItemDefualt,
  SetTransactionSummary,
} from "@/helper/transactionHelper";
import {
  GetTransactionSummary,
  ToCreateBookmark,
  TransactionValidationAndRemoveTransactionItemEmpty,
} from "@/helper/transactionItemHelper";
import { i18n } from "@/i18n";
import API from "@/service/index";
import {
  ConvertBookmarkDetailToTransactionDetail,
  ConvertToAISuggestionAccountByContact,
  ConvertToInvoiceDetail,
} from "@/service/transaction/transactionFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Transaction extends VuexModule {
  private aiSuggestionTransaction: any = null;
  private aiSuggestionTransactionLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private isAutoSuggestion = false;
  private transactionCreateLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private transactionNumberLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private transactionCopyLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public bookmarkListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public bookmarkDetailListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public transactionByBookmarkIdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public createBookmarkLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public bookmarkList: any = [];
  public bookmarkDetailList: any = [];
  private transcationResult: any = null;
  public isCanOpenModalCreateBookmark = false;
  public deleteBookmarkLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public tagListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public tagList: any = [];
  public createNewTagLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public createNewTagRes: any = null;
  public isShowModalConfirmCreditLimit = false;

  get getAiSuggestionTransaction() {
    return this.aiSuggestionTransaction;
  }
  get getAiSuggestionTransactionLoadingStatus() {
    return this.aiSuggestionTransactionLoadingStatus;
  }
  get getIsAutoSuggestion() {
    return this.isAutoSuggestion;
  }
  get getTransactionNumberLoadingStatus(): LoadingStatusType {
    return this.transactionNumberLoadingStatus;
  }
  get getTransactionCreateLoadingStatus(): LoadingStatusType {
    return this.transactionCreateLoadingStatus;
  }
  get getTransactionCopyLoadingStatus(): LoadingStatusType {
    return this.transactionCopyLoadingStatus;
  }
  get getCreateBookmarkLoadingStatus(): LoadingStatusType {
    return this.createBookmarkLoadingStatus;
  }
  get getDeleteBookmarkLoadingStatus(): LoadingStatusType {
    return this.deleteBookmarkLoadingStatus;
  }
  get getTranscationResult(): any {
    return this.transcationResult;
  }
  get getBookmarkListLoadingStatus(): any {
    return this.bookmarkListLoadingStatus;
  }
  get getBookmarkDetailListLoadingStatus(): LoadingStatusType {
    return this.bookmarkDetailListLoadingStatus;
  }
  get getTransactionByBookmarkIdLoadingStatus(): LoadingStatusType {
    return this.transactionByBookmarkIdLoadingStatus;
  }
  get getBookmarkList(): any {
    return this.bookmarkList;
  }
  get getBookmarkDetailList(): any {
    return this.bookmarkDetailList;
  }
  get getIsCanOpenModalCreateBookmark(): any {
    return this.isCanOpenModalCreateBookmark;
  }
  get getTagListLoadingStatus(): LoadingStatusType {
    return this.tagListLoadingStatus;
  }
  get getTagList(): any {
    return this.tagList;
  }
  get getCreateNewTagLoadingStatus(): LoadingStatusType {
    return this.createNewTagLoadingStatus;
  }
  get getCreateNewTagRes(): any {
    return this.createNewTagRes;
  }
  get getShowModalConfirmCreditLimit(): any {
    return this.isShowModalConfirmCreditLimit;
  }

  @Mutation
  public MutationOnChangeTransactionItem(transactionCreate: any) {
    SetTransactionSummary(transactionCreate);
    CheckErrorValueInput(transactionCreate);
  }

  @Mutation
  public MutationOnHumanEventChangeTransactionItem(transactionCreate: any) {
    transactionCreate.isNotAuto = false;
    SetTransactionSummary(transactionCreate);
    CheckErrorValueInput(transactionCreate);
  }

  @Mutation
  public MutationCheckErrorValueInputForCreateTransaction(transactionCreate: any) {
    CheckErrorValueInput(transactionCreate);
  }

  @Mutation
  public MutationOnChangeWhtPayment(input: any) {
    const transactionCreate = input.transactionCreate;
    const paymentGroup = input.paymentGroup;
    const isFromEvent = input.isFromEvent ? input.isFromEvent : false;
    const isReturnWhtAmountToPayment = input.isReturnWhtAmountToPayment ? input.isReturnWhtAmountToPayment : false;
    CalculateWhtAmount(
      transactionCreate.transactionSummary.netAmount.ToNumber(),
      transactionCreate.transactionSummary.subTotalForCalculateWht,
      paymentGroup
    );
    OnChangeWht(paymentGroup, isFromEvent, isReturnWhtAmountToPayment);
    CalculateAllPaymentGroupSummary(transactionCreate.payment);
    CheckErrorValueInput(transactionCreate);
  }

  @Mutation
  public MutationOnChangePaymentGroup(transactionCreate: any) {
    CalculateAllPaymentGroupSummary(transactionCreate.payment);
    CheckErrorValueInput(transactionCreate);
  }

  @Mutation
  public MutationSetAiSuggestionTransactionLoadingStatus(status: LoadingStatusType) {
    this.aiSuggestionTransactionLoadingStatus = status;
  }

  @Mutation
  public MutationSetAiSuggestionTransaction(aiSuggestionTransaction: any) {
    this.aiSuggestionTransaction = aiSuggestionTransaction;
  }

  @Mutation
  public MutationSetTransactionCreateLoadingStatus(status: LoadingStatusType) {
    this.transactionCreateLoadingStatus = status;
  }

  @Mutation
  public MutationSetTransactionCopyLoadingStatus(status: LoadingStatusType) {
    this.transactionCopyLoadingStatus = status;
  }

  @Mutation
  public MutationSetTransactionNumberLoadingStatus(status: LoadingStatusType) {
    this.transactionNumberLoadingStatus = status;
  }

  @Mutation
  public MutationSetTransactionResult(result: any) {
    this.transcationResult = result;
  }

  @Mutation
  public MutationGetCreateBookmarkLoadingStatus(status: LoadingStatusType) {
    this.createBookmarkLoadingStatus = status;
  }

  @Mutation
  public MutationGetDeleteBookmarkLoadingStatus(status: LoadingStatusType) {
    this.deleteBookmarkLoadingStatus = status;
  }

  @Mutation
  public MutationGetBookmarkListLoadingStatus(status: LoadingStatusType) {
    this.bookmarkListLoadingStatus = status;
  }

  @Mutation
  public MutationGetBookmarkList(bookmarkList: any) {
    this.bookmarkList = bookmarkList;
  }

  @Mutation
  public MutationGetBookmarkDetailListLoadingStatus(status: LoadingStatusType) {
    this.bookmarkDetailListLoadingStatus = status;
  }

  @Mutation
  public MutationGetTransactionByBookmarkIdLoadingStatus(status: LoadingStatusType) {
    this.transactionByBookmarkIdLoadingStatus = status;
  }

  @Mutation
  public MutationGetBookmarkDetailList(bookmarkDetailList: any) {
    this.bookmarkDetailList = bookmarkDetailList;
  }

  @Mutation
  public MutationIsCanOpenModalCreateBookmark(isCanOpenModal: boolean) {
    this.isCanOpenModalCreateBookmark = isCanOpenModal;
  }

  @Mutation
  public MutationTagListLoadingStatus(status: LoadingStatusType) {
    this.tagListLoadingStatus = status;
  }

  @Mutation
  public MutationTagList(tagList: any) {
    this.tagList = tagList;
  }

  @Mutation
  public MutationCreateNewTagLoadingStatus(status: LoadingStatusType) {
    this.createNewTagLoadingStatus = status;
  }

  @Mutation
  public MutationCreateNewTag(createNewTagRes: any) {
    this.createNewTagRes = createNewTagRes;
  }

  @Mutation
  public MutationSetShowModalConfirmCreditLimit(isShow: boolean) {
    this.isShowModalConfirmCreditLimit = isShow;
  }

  @Action
  public DoAddTransactionItem(transactionCreate: any) {
    const transactionItem = GetCreateTransactionItemDefualt(transactionCreate.expenseType);
    transactionCreate.transactionItemList.push(transactionItem);
  }
  @Action
  public DoRemoveTransactionItem(input: any) {
    if (input.transactionCreate.transactionItemList.length > 1) {
      input.transactionCreate.transactionItemList.splice(input.index, 1);
    }
  }

  @Action
  DoGetSuggestionTransactionNumber(transactionCreate: any) {
    if (this.transactionNumberLoadingStatus !== LoadingStatusType.Loading && transactionCreate.date.value) {
      transactionCreate.number.disabled = true;
      transactionCreate.number.value = "";
      this.context.commit("MutationSetTransactionNumberLoadingStatus", LoadingStatusType.Loading);

      API.TransactionService.DoGetSuggestionTransactionNumber(transactionCreate).then((res) => {
        transactionCreate.number.disabled = false;
        if (res.data.responseCode == "200") {
          transactionCreate.number.value = res.data.number;
        }
        this.context.commit("MutationSetTransactionNumberLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetAISuggestionAccountByContact(input: any) {
    if (this.aiSuggestionTransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetAiSuggestionTransactionLoadingStatus", LoadingStatusType.Loading);
      API.TransactionService.DoGetAISuggestionAccountByContact(
        input.contactId,
        input.contactTaxId,
        input.transactionCreate.financeType,
        input.transactionCreate.expenseType
      ).then((res) => {
        const aiSuggestionTransaction = ConvertToAISuggestionAccountByContact(res.data.aiSuggestionTransaction);

        this.context.commit("MutationSetAiSuggestionTransaction", aiSuggestionTransaction);
        this.context.commit("MutationSetAiSuggestionTransactionLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetPeakAIRecommendation(input: any) {
    if (this.aiSuggestionTransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetAiSuggestionTransactionLoadingStatus", LoadingStatusType.Loading);
      if (input.aiSuggestionTransaction.transactionId > 0) {
        API.TransactionService.DoGetInvoiceDetail(input.aiSuggestionTransaction.transactionId).then((res) => {
          const transactionDetail = ConvertToInvoiceDetail(res.data);

          SetAIInvoice(input.transactionCreate, transactionDetail);
          if (input.expenseType == ExpenseType.Expense) {
            input.transactionCreate.transactionItemList.forEach((item: any) => {
              if (item.productTemplate != null) {
                item.productTemplate.id = 0;
              }
            });
          }
          this.context.commit("MutationSetAiSuggestionTransactionLoadingStatus", LoadingStatusType.Success);
          this.context.commit("MutationSetAiSuggestionTransaction", null);
        });
      } else {
        SetAIChartOfAccount(input.transactionCreate, input.contactId, input.aiSuggestionTransaction, input.expenseType);
        this.context.commit("MutationSetAiSuggestionTransactionLoadingStatus", LoadingStatusType.Success);
        this.context.commit("MutationSetAiSuggestionTransaction", null);
      }
    }
  }

  @Action
  public DoGetInvoiceCopy(input: any) {
    if (this.transactionCreateLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetTransactionCopyLoadingStatus", LoadingStatusType.Loading);
      API.TransactionService.DoGetInvoiceDetail(input.invoiceId).then((res) => {
        const transactionDetail = ConvertToInvoiceDetail(res.data);
        SetCopyInvoiceModel(input.transactionCreate, transactionDetail);
        this.context.commit("MutationSetTransactionCopyLoadingStatus", LoadingStatusType.Success);
        this.context.commit("MutationSetAiSuggestionTransaction", null);
      });
    }
  }

  @Action
  public DoReSetAISuggestionTransaction() {
    this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.None);
    this.context.commit("MutationSetAiSuggestionTransaction", null);
  }

  @Action
  public DoCreateInvoice(input: any) {
    CheckErrorValueInput(input.transactionCreate);
    const isTransactionValidateError = TransactionValidationAndRemoveTransactionItemEmpty(input.transactionCreate);
    if (!isTransactionValidateError && this.transactionCreateLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Loading);
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      API.TransactionService.DoCreateInvoice(input.status, input.transactionCreate).then(async (res) => {
        if (res.data.responseCode.IsSuccess()) {
          // insert fileList to transaction
          const fileList = input.transactionCreate.fileList;
          if (fileList && fileList.length > 0) {
            for (const file of fileList) {
              await API.TransactionService.DoInsertInvoiceFile({
                transactionId: res.data.transaction.id,
                fileList: [file],
              });
            }
          }
          this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Success);
          this.context.commit("MutationSetTransactionResult", res.data.transaction);

          inputAlert.alertMessage = "สร้างเอกสารสำเร็จ ";
          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        } else {
          if (res.data.exception.code == PeakExceptionResponseCode.TransactionNumberDuplicated) {
            inputAlert.alertMessage = "เลขที่เอกสารซ้ำ";
            input.transactionCreate.number.validateError = true;
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });

            this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Fail);
          } else if (res.data.exception.code == PeakExceptionResponseCode.CreditLimitCannontCreate) {
            inputAlert.alertMessage = i18n.t("Extension_CreditLimit_Amount");
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });

            this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Fail);
          } else if (res.data.exception.code == PeakExceptionResponseCode.CreditLimitWarning) {
            this.context.commit("MutationSetShowModalConfirmCreditLimit", true);
            this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Fail);
          } else {
            inputAlert.alertMessage = "สร้างเอกสารไม่สำเร็จ";
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
            this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Fail);
          }
        }
      });
    }
  }

  @Action
  public DoCreatePurchaseInventory(input: any) {
    CheckErrorValueInput(input.transactionCreate);
    const isTransactionValidateError = TransactionValidationAndRemoveTransactionItemEmpty(input.transactionCreate);
    if (!isTransactionValidateError && this.transactionCreateLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Loading);
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      API.TransactionService.DoCreatePurchaseInventory(input.status, input.transactionCreate).then(async (res) => {
        if (res.data.responseCode.IsSuccess()) {
          // insert fileList to transaction
          const fileList = input.transactionCreate.fileList;
          if (fileList && fileList.length > 0) {
            for (const file of fileList) {
              await API.TransactionService.DoInsertInvoiceFile({
                transactionId: res.data.transaction.id,
                fileList: [file],
              });
            }
          }
          this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Success);
          this.context.commit("MutationSetTransactionResult", res.data.transaction);

          inputAlert.alertMessage = "สร้างเอกสารสำเร็จ ";
          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        } else {
          if (res.data.exception.code == PeakExceptionResponseCode.TransactionNumberDuplicated) {
            inputAlert.alertMessage = "เลขที่เอกสารซ้ำ";
            input.transactionCreate.number.validateError = true;
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });

            this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Fail);
          } else if (res.data.exception.code == PeakExceptionResponseCode.CreditLimitCannontCreate) {
            inputAlert.alertMessage = i18n.t("Extension_CreditLimit_Amount");
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });

            this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Fail);
          } else if (res.data.exception.code == PeakExceptionResponseCode.CreditLimitWarning) {
            this.context.commit("MutationSetShowModalConfirmCreditLimit", true);
            this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Fail);
          } else {
            inputAlert.alertMessage = "สร้างเอกสารไม่สำเร็จ";
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
            this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Fail);
          }
        }
      });
    }
  }

  @Action
  public DoResetShowModalConfirmCreditLimit() {
    this.context.commit("MutationSetShowModalConfirmCreditLimit", false);
  }

  @Action
  public DoCreateQuotation(input: any) {
    CheckErrorValueInput(input.transactionCreate);
    const isTransactionValidateError = TransactionValidationAndRemoveTransactionItemEmpty(input.transactionCreate);
    if (!isTransactionValidateError && this.transactionCreateLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Loading);
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      API.TransactionService.DoCreateQuotation(input.status, input.transactionCreate).then(async (res) => {
        if (res.data.responseCode.IsSuccess()) {
          // insert fileList to transaction
          const fileList = input.transactionCreate.fileList;
          if (fileList && fileList.length > 0) {
            for (const file of fileList) {
              await API.TransactionService.DoInsertQuotationFile({
                transactionId: res.data.transaction.id,
                fileList: [file],
              });
            }
          }
          this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Success);
          this.context.commit("MutationSetTransactionResult", res.data.transaction);

          inputAlert.alertMessage = "สร้างเอกสารสำเร็จ ";
          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
          this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Success);
        } else {
          if (res.data.exception.code == PeakExceptionResponseCode.TransactionNumberDuplicated) {
            inputAlert.alertMessage = "เลขที่เอกสารซ้ำ";
            input.transactionCreate.number.validateError = true;
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });

            this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Fail);
          } else if (res.data.exception.code == PeakExceptionResponseCode.CreditLimitCannontCreate) {
            inputAlert.alertMessage = i18n.t("Extension_CreditLimit_Amount");
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });

            this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Fail);
          } else if (res.data.exception.code == PeakExceptionResponseCode.CreditLimitWarning) {
            this.context.commit("MutationSetShowModalConfirmCreditLimit", true);
            this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Fail);
          } else {
            inputAlert.alertMessage = "สร้างเอกสารไม่สำเร็จ";
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });

            this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Fail);
          }
        }
      });
    }
  }

  @Action
  public DoCreateReceipt(input: any) {
    CheckErrorValueInput(input.transactionCreate);
    const isTransactionValidateError = TransactionValidationAndRemoveTransactionItemEmpty(input.transactionCreate);
    if (!isTransactionValidateError && this.transactionCreateLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Loading);
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      API.TransactionService.DoCreateReceipt(input.status, input.transactionCreate).then(async (res) => {
        if (res.data.responseCode.IsSuccess()) {
          // insert fileList to transaction
          const fileList = input.transactionCreate.fileList;
          if (fileList && fileList.length > 0) {
            for (const file of fileList) {
              await API.TransactionService.DoInsertReceiptFile({
                transactionId: res.data.transaction.id,
                fileList: [file],
              });
            }
          }
          this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Success);
          this.context.commit("MutationSetTransactionResult", res.data.transaction);

          inputAlert.alertMessage = "สร้างเอกสารสำเร็จ ";
          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        } else {
          inputAlert.alertMessage = "สร้างเอกสารไม่สำเร็จ";
          inputAlert.typeMessage = TypeComponentNoti.Error;
          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
          this.context.commit("MutationSetTransactionCreateLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }

  @Action
  public DoGetBookmarkList(input: any) {
    if (this.bookmarkListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationGetBookmarkListLoadingStatus", LoadingStatusType.Loading);
      API.TransactionService.DoGetBookmarkList(input).then((res) => {
        if (res.status.IsSuccess()) {
          this.context.commit("MutationGetBookmarkList", res.data.bookmarkList);
        }
        this.context.commit("MutationGetBookmarkListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public ValidateBeforeOpenCreateBookmarkModal(input: any) {
    CheckErrorValueInput(input.transactionCreate);
    const isTransactionValidateError = TransactionValidationAndRemoveTransactionItemEmpty(input.transactionCreate);
    if (!isTransactionValidateError) {
      this.context.commit("MutationIsCanOpenModalCreateBookmark", true);
    } else {
      this.context.commit("MutationIsCanOpenModalCreateBookmark", false);
    }
  }

  @Action
  public CloseCreateBookmarkModal(input: any) {
    this.context.commit("MutationIsCanOpenModalCreateBookmark", false);
  }

  @Action
  public DoCreateBookmark(input: any) {
    if (this.createBookmarkLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationGetCreateBookmarkLoadingStatus", LoadingStatusType.Loading);
      const summary = GetTransactionSummary(input.transaction);
      const bookmarkModel = ToCreateBookmark(input, summary);
      API.TransactionService.DoCreateBookmark(bookmarkModel).then((res) => {
        if (res.status.IsSuccess()) {
          this.context.commit("MutationGetBookmarkListLoadingStatus", LoadingStatusType.None);
          this.context.commit("MutationGetCreateBookmarkLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }
  @Action
  public DoDeleteBookmark(bookmarkId: number) {
    if (this.deleteBookmarkLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationGetDeleteBookmarkLoadingStatus", LoadingStatusType.Loading);
      API.TransactionService.DoDeleteBookmark(bookmarkId).then((res) => {
        if (res.status.IsSuccess()) {
          this.context.commit("MutationGetBookmarkListLoadingStatus", LoadingStatusType.None);
          this.context.commit("MutationGetDeleteBookmarkLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }

  @Action
  public DoGetBookmarkDetailList(transactionTemplateId: number) {
    if (this.bookmarkDetailListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationGetBookmarkDetailListLoadingStatus", LoadingStatusType.Loading);
      API.TransactionService.DoGetBookmarkDetailList(transactionTemplateId).then((res) => {
        if (res.status.IsSuccess()) {
          this.context.commit("MutationGetBookmarkDetailList", res.data.bookmarkTemplateList);
        }
        this.context.commit("MutationGetBookmarkDetailListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetBookmarkForTransactionTemplate(input: any) {
    if (this.transactionByBookmarkIdLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationGetTransactionByBookmarkIdLoadingStatus", LoadingStatusType.Loading);
      API.TransactionService.DoGetBookmarkForTransactionTemplate(input.bookmarkId).then((res) => {
        if (res.status.IsSuccess()) {
          SetBookmarkForTransaction(
            input.transactionCreate,
            ConvertBookmarkDetailToTransactionDetail(res.data.bookmarkDetailModel)
          );
          this.context.commit("MutationGetTransactionByBookmarkIdLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }
  @Action
  public DoGetTagList() {
    if (this.tagListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationTagListLoadingStatus", LoadingStatusType.Loading);
      API.TransactionService.DoGetTagList().then((res) => {
        if (res.status.IsSuccess()) {
          this.context.commit("MutationTagList", res.data.tagList);
        }
        this.context.commit("MutationTagListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoCreateNewTag(input: any) {
    if (this.createBookmarkLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationCreateNewTagLoadingStatus", LoadingStatusType.Loading);
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      API.TransactionService.DoCreateNewTag(input).then((res) => {
        if (res.status.IsSuccess()) {
          this.context.commit("MutationCreateNewTag", { tagName: input.tagName, tagId: res.data.tagId });
          inputAlert.alertMessage = "เพิ่มแท็กสำเร็จ ";
          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
          this.context.commit("MutationCreateNewTagLoadingStatus", LoadingStatusType.Success);
        } else {
          inputAlert.alertMessage = "เพิ่มแท็กไม่สำเร็จ";
          inputAlert.typeMessage = TypeComponentNoti.Error;
          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
          this.context.commit("MutationCreateNewTagLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }
}
